import type { LinkData } from './LinkItem.tsx';

export type ApplyTopLinksPinToggleResult = {
	nextLinks: LinkData[];
	/** True when pin/unpin changed list order (run layout animation). */
	didReorder: boolean;
};

/**
 * Toggles pin on a link.
 * - Pinning: move after the last currently pinned item (left / pinned group in LTR).
 * - Unpinning: move to the end of the list with other unpinned items.
 */
export function applyTopLinksPinToggle(
	links: LinkData[],
	linkId: string,
): ApplyTopLinksPinToggleResult {
	const idx = links.findIndex((l) => l.id === linkId);
	if (idx === -1) {
		return { nextLinks: links, didReorder: false };
	}
	const link = links[idx];
	if (link.isPinned) {
		const without = links.filter((_, i) => i !== idx);
		const updatedLink = { ...link, isPinned: false };
		const nextLinks = [...without, updatedLink];
		const newIndex = without.length;
		const didReorder = idx !== newIndex;

		return { nextLinks, didReorder };
	}

	const without = links.filter((_, i) => i !== idx);
	let insertAt = 0;
	for (let i = without.length - 1; i >= 0; i--) {
		if (without[i].isPinned) {
			insertAt = i + 1;
			break;
		}
	}
	const updatedLink = { ...link, isPinned: true };
	const nextLinks = [...without.slice(0, insertAt), updatedLink, ...without.slice(insertAt)];
	const didReorder = insertAt !== idx;

	return { nextLinks, didReorder };
}
